/**
 * Who may open a department dashboard. Admins see them all; a named role lets
 * somebody outside admin see one without being given everything else admin holds.
 * The route guard and the menu both read these, so the two cannot drift.
 */
export const PROJECTS_DASHBOARD_ROLES = ['admin', 'projects-dashboard'];

export const PRODUCTION_DASHBOARD_ROLES = ['admin', 'production-dashboard'];
